module.exports = __webpack_public_path__ + "img/icon-download-all.b9bf02be.svg";